import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 3,
      left: 0,
      position: 'absolute',
      top: 0,
      width: '100%',
      zIndex: 1,
    },
  })
);

const Loader = () => {
  const classes = useStyles();
  return <LinearProgress className={classes.root} />;
};

export default Loader;
